import React from 'react'

import CardColumn from '@SonarCX/components/atoms/CardColumn'
import ArticleCard from './ArticleCard'

import { sortItems } from '@SonarCX/slices/article'
import useStyles from './styles'

type ArticleCardsProps = {
  items: APIArticleGeneral[]
}

const ArticleCards: React.FC<ArticleCardsProps> = ({ items }) => {
  const sorted = React.useMemo(
    () => sortItems(items) as APIArticleGeneral[],
    [items]
  )

  const classes = useStyles()

  return (
    <CardColumn className={classes.root}>
      {sorted.map(article => (
        <ArticleCard key={article.id} article={article} />
      ))}
    </CardColumn>
  )
}

export default ArticleCards
